import { ERROR_LEAD_CODE_TRANSLATE, Lead, LEAD_ERROR_CODE, LEAD_ERRORS } from 'Pages/partnerProfile'
import { FieldNames } from 'Constants/FieldNames'

export const getTypeError = (errors): LEAD_ERRORS => {
	const keys = Object.keys(errors ?? [])
	if (keys.includes(LEAD_ERRORS.USER)) return LEAD_ERRORS.USER
	if (keys.includes(LEAD_ERRORS.PARENT)) return LEAD_ERRORS.PARENT
	if (keys.includes(LEAD_ERRORS.PARTNER)) return LEAD_ERRORS.PARTNER
	if (keys.includes(LEAD_ERRORS.LEAD_PARENT)) return LEAD_ERRORS.LEAD_PARENT
	return LEAD_ERRORS.LEAD
}

export const getErrorCodeLead = (errors) =>
	(errors ?? [])[LEAD_ERRORS.LEAD] ?? LEAD_ERROR_CODE.UNKNOWN

export const getErrorCodeLeadParent = (errors) => (errors ?? [])[LEAD_ERRORS.LEAD_PARENT]

export const getTranslateCodeError = (errors): string =>
	ERROR_LEAD_CODE_TRANSLATE[getErrorCodeLead(errors)]

export const isEqualFio = (values: Lead, lead: Lead): boolean => {
	return (
		`${values[FieldNames.FIRST_NAME] ?? ''}${values[FieldNames.LAST_NAME] ?? ''}${
			values[FieldNames.MIDDLE_NAME] ?? ''
		}`.trim() !==
		`${lead?.parent?.[FieldNames.CEO_FIRST_NAME] ?? ''}${
			lead?.parent?.[FieldNames.CEO_LAST_NAME] ?? ''
		}${lead?.parent?.[FieldNames.CEO_MIDDLE_NAME] ?? ''}`.trim()
	)
}

export const getRealError = (errors) => {
	const key = Object.keys(errors?.data?.errors?.[0])?.[0]
	const value = errors?.data?.errors?.[0][key]
	return `${errors?.status}: ${key}:"${value}"`
}
